import React, { Suspense } from 'react';
import style from 'styled-components';
import EmbeddedScript from '../EmbeddedScript';
import renderCTAOptions from '../renderCTAOptions';
import { HeroTemplate2 as HeroTemplate2Props } from './types/types';

const HeroContainer = style.div`
margin-top: 64px;

a {
  margin: 30px auto;

  @media (max-width: 576px) {
    margin: 25px auto 2rem;
  }
}

div.row {
  margin: auto;
}

div.row > span:first-child > a {
  margin-right: 16px;
}

.col-xs-12 {
  padding: 0;
}

.padding--2x-r {
  padding-right: 2rem;
}

@media (max-width: 768px) {
  p:last-child {
    margin-bottom: 2rem;
  }

  h1 {
    padding: 0;
    width: 60%;
  }

  .padding--0-sm-r {
    padding-right: 0;
  }
}

@media (max-width: 576px) {
  h1 {
    width: 100%;
  }
}
`;

const HeroTemplate2 = ({
  h1Header, mobileCtas, buttonPlacementBelowSubcopy, bodyCopy1, bodyCopy2, bodyCopy3, embeddedScript,
}: HeroTemplate2Props) => {
  const isSSR = typeof window === 'undefined';

  return (
    <HeroContainer
      data-component-type="hero-template-2"
    >
      <div className="row row-small">
        <div className="col-xs-12 left__content align--center">
          <h1>{h1Header}</h1>
          {mobileCtas?.length !== 0 && !buttonPlacementBelowSubcopy
            && (
              <div className="row">
                {mobileCtas?.map((item, index) => (
                  <span key={index}>
                    {renderCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
                  </span>
                ))}
              </div>
            )}
          {bodyCopy1
            && (
            <p className={`body__copy--large padding--2x-r padding--0-sm-r ${buttonPlacementBelowSubcopy
              ? 'margin__top--1x' : ''}`}
            >
              {bodyCopy1}
            </p>
            )}
          {bodyCopy2
            && <p className="body__copy--large padding--2x-r padding--0-sm-r">{bodyCopy2}</p>}
          {bodyCopy3
            && <p className="body__copy--large padding--2x-r padding--0-sm-r">{bodyCopy3}</p>}
          {mobileCtas?.length !== 0 && buttonPlacementBelowSubcopy
            && (
              <div className="row">
                {mobileCtas?.map((item, index) => (
                  <span key={index}>
                    {renderCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
                  </span>
                ))}
              </div>
            )}
          {embeddedScript && !isSSR && (
            embeddedScript.map((item, index) => (
              <Suspense fallback={<div />}>
                <EmbeddedScript
                  key={index}
                  scriptSource={item.scriptSource}
                  scriptInnerHtml={item.scriptInnerHtml}
                  scriptAppendToId={item.scriptAppendToId}
                  embeddedHtml={item.embeddedHtml}
                />
              </Suspense>
            ))
          )}
        </div>
      </div>
    </HeroContainer>
  );
};

export default HeroTemplate2;
